import React from 'react';
import { ListWrapper } from '@builtbypixel/nucleus';
import { Button, Icon } from '@builtbypixel/plasma';
import { Link } from 'react-router-dom';
import setup from './setup';
import { MdCheck } from 'react-icons/md';

// Extra Menu appears next to the create button
const extraMenu = () => {
    return null;
};

const List = () => {
    const columns = [
        {
            Header: 'Name',
            accessor: 'name',
            Cell: ({ row }) => (
                <Link
                    to={`${setup.model}/edit/${row.original[setup.accessor]}`}
                >
                    <Button variant='link' variantColor='secondary'>
                        {row.original.name}
                    </Button>
                </Link>
            ),
        },
        {
            Header: 'Slug',
            accessor: 'slug',
            Cell: ({ row }) => <pre>{row.original.slug}</pre>,
        },
        {
            Header: 'Type',
            accessor: 'type.name',
        },
        {
            Header: 'Configurable',
            accessor: 'configurable',
            Cell: ({ value }) =>
                value ? (
                    <Icon fontSize='20px' color='success'>
                        <MdCheck />
                    </Icon>
                ) : null,
        },
    ];

    return (
        <ListWrapper setup={setup} columns={columns} extraMenu={extraMenu} />
    );
};

export default List;
